<template>
  <div>
    <div v-if="showEveryoneOil">
      <!-- 返回 开始 -->
      <div class="page_topbox">
        <img
          class="page_topreturn"
          src="/static/fanhui.png"
          @click="pageReturn()"
        />
        <div class="page_toptext">油卡充值</div>
        <img
          class="page_topreturnindex"
          src="/static/fanhuishouye.png"
          @click="pageToIndex()"
        />
      </div>
      <!-- 返回 结束 -->
      <!-- 顶部tab 开始 -->
      <div class="oilcar_tab" v-if="usershowtab">
        <div
          class="oilcar_tablist"
          v-for="(item, index) in topHead"
          @click="changetophead(index)"
        >
          <div :class="item.topselect ? 'oilcar_tabname' : 'oilcar_tabname1'">
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 顶部tab 结束 -->
      <!-- 大家来加油 开始 -->
      <!-- <div v-if="topheadindex===1"> -->
      <!-- 输入手机 开始 -->
      <!-- <div class="oilcar_top">
          <div class="oilcar_pname">手机号码</div>
          <div class="oilcar_pnum">
            <input class="oilcar_pnuminput" @input="phoneNum()" placeholder="请输入手机号" type="tel" value="phone" v-model="phonenum" />
            <img class="oilcar_pimg" src="/static/newicon/chongzhiphone.png" />
          </div>
          <div class="oilcar_pnum" v-if="phone!=phonenum">
            <input class="oilcar_pnuminput1" type="number" placeholder="请输入验证码" v-model="phoneCode" />
            <div class="oilcar_yanzheng" @click='getPhoneCode()'>{{ currentTime ? currentTime : "获取验证码" }}</div>
          </div>
        </div> -->
      <!-- 输入手机 结束 -->
      <!-- 套餐选择 开始 -->
      <!-- <div :class="phone!=phonenum? 'oilcar_taocan1' : 'oilcar_taocan'">
          <div class="oilcar_taocan_name">请选择充值金额</div>
          <div class="oilcar_taocan_list">
            <div :class="item.checked? 'oilcar_taocan_box1' :'oilcar_taocan_box' " v-for="(item,index) in packageList"
              @click="selectnum(index)">
              <div class="oilcar_taocan_num2">{{item.name}}</div>
              <img v-if="item.checked" class="oilcar_taocan_checkimg" src="/static/newprojecticon/chongzhicheck.png" />
            </div>
          </div>
        </div> -->
      <!-- 套餐选择 结束 -->
      <!-- <div :class="phone!=phonenum? 'oiltype_taocan1' : 'oiltype_taocan'">
          <div class="pagepaytype_text">选择支付方式</div> -->
      <!--    <div class="page_shangpin_box" @click="weixinPay()">
          <div class="page_shangpin_mesgname1">
            <img src="/static/weixinpay.png" class="page_shangpin_mesglogo" />
            <div class="page_shangpin_mesgname">微信支付</div>
          </div>
          <div class="page_shangpin_usejifen">
            <div class="page_shangpin_shoujia">{{ checknum ? checknum+'元' : '' }}</div>
            <img :src="isWeixinPay? '/static/checkdeicon.png' : '/static/checkicon.png'" class="page_checklogo" />
          </div>
        </div> -->
      <!-- <div class="page_shangpin_box" @click="cardPay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/kaquanpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">卡券支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_shoujia">{{ cardPrice ? cardPrice+'元' : '' }}</div>
              <img :src="isCardPay? '/static/checkdeicon.png' : '/static/checkicon.png'" class="page_checklogo" />
            </div>
          </div>
          <div class="page_shangpin_box" @click="yuePay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">积分支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_keyong">可用积分</div>
              <div class="page_shangpin_shoujia">{{amount}}</div>
              <img :src="isCardPay? '/static/checkicon.png' : '/static/checkdeicon.png'" class="page_checklogo" />
            </div>
          </div>
        </div> -->
      <!-- 支付 开始 -->
      <!-- <div :class="phone!=phonenum?'oilcar_button1' : 'oilcar_button'" @click="zhifu()">
          <div class="oilcar_zhifu">立即支付{{isCardPay ? '' : ('（'+checknum+'积分）')}}</div>
        </div> -->
      <!-- 支付 结束 -->
      <!-- 注意事项 开始 -->
      <!-- <div class="oilcar_mesg">
          <div class="oilcar_mesgtitle">
            <img class="oilcar_mesgimg" src="/static/newprojecticon/title.png" />
            <div class="oilcar_mesgtext">注意事项</div>
          </div>
          <div class="oilcar_mesgtipspan2">大家来加油是中石化加油券</div>
          <div class="oilcar_mesgtip">1、石化电子加油券产品将于2022年7月31日起暂停销售，已下单的请您在券的有效期内使用完，过期之后无法补发，如造成损失请自行承担。</div>
          <div class="oilcar_mesgtip">2、请认真核对充值号信息，对个人输入有误产生的售后问题概不受理。</div>
          <div class="oilcar_mesgtip">3、充值成功后，搜索“<span class="oilcar_mesgtipspan1">大家来加油</span>”小程序，授权微信并使用充值的手机号码登录，点击“电子加油券”设置支付密码后，即可到加油站打开二维码支付使用。
          </div>
        </div> -->
      <!-- 注意事项 结束 -->
      <!-- </div> -->
      <!-- 大家来加油 结束 -->
      <!-- 广东中石油 开始 -->
      <div v-if="topheadindex === 1">
        <!-- 输入手机 开始 -->
        <div class="oilcar_top">
          <div class="oilcar_pname">手机号码</div>
          <div class="oilcar_pnum">
            <input
              class="oilcar_pnuminput"
              @input="phoneNum()"
              placeholder="请输入手机号"
              type="tel"
              value="phone"
              v-model="phonenum"
            />
            <img class="oilcar_pimg" src="/static/newicon/chongzhiphone.png" />
          </div>
          <div class="oilcar_pnum" v-if="phone != phonenum">
            <input
              class="oilcar_pnuminput1"
              type="number"
              placeholder="请输入验证码"
              v-model="phoneCode"
            />
            <div class="oilcar_yanzheng" @click="getPhoneCode()">
              {{ currentTime ? currentTime : "获取验证码" }}
            </div>
          </div>
        </div>
        <!-- 输入手机 结束 -->
        <!-- 套餐选择 开始 -->
        <div :class="phone != phonenum ? 'oilcar_taocan1' : 'oilcar_taocan'">
          <div class="oilcar_taocan_name">请选择充值金额</div>
          <div class="oilcar_taocan_list">
            <div
              :class="item.checked ? 'oilcar_taocan_box1' : 'oilcar_taocan_box'"
              v-for="(item, index) in packageList"
              @click="selectnum(index)"
            >
              <div class="oilcar_taocan_num2">{{ item.name }}</div>
              <img
                v-if="item.checked"
                class="oilcar_taocan_checkimg"
                src="/static/newprojecticon/chongzhicheck.png"
              />
            </div>
          </div>
        </div>
        <!-- 套餐选择 结束 -->
        <div :class="phone != phonenum ? 'oiltype_taocan1' : 'oiltype_taocan'">
          <div class="pagepaytype_text">选择支付方式</div>
          <!--    <div class="page_shangpin_box" @click="weixinPay()">
          <div class="page_shangpin_mesgname1">
            <img src="/static/weixinpay.png" class="page_shangpin_mesglogo" />
            <div class="page_shangpin_mesgname">微信支付</div>
          </div>
          <div class="page_shangpin_usejifen">
            <div class="page_shangpin_shoujia">{{ checknum ? checknum+'元' : '' }}</div>
            <img :src="isWeixinPay? '/static/checkdeicon.png' : '/static/checkicon.png'" class="page_checklogo" />
          </div>
        </div> -->
          <div class="page_shangpin_box" @click="cardPay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/kaquanpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">卡券支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_shoujia">
                {{ cardPrice ? cardPrice + "元" : "" }}
              </div>
              <img
                :src="
                  isCardPay
                    ? '/static/checkdeicon.png'
                    : '/static/checkicon.png'
                "
                class="page_checklogo"
              />
            </div>
          </div>
          <div class="page_shangpin_box" @click="yuePay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">积分支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_keyong">可用积分</div>
              <div class="page_shangpin_shoujia">{{ amount }}</div>
              <img
                :src="
                  isCardPay
                    ? '/static/checkicon.png'
                    : '/static/checkdeicon.png'
                "
                class="page_checklogo"
              />
            </div>
          </div>
        </div>
        <!-- 支付 开始 -->
        <div
          :class="phone != phonenum ? 'oilcar_button1' : 'oilcar_button'"
          @click="zhifu()"
        >
          <!-- （{{checknum}}积分） -->
          <div class="oilcar_zhifu">
            立即支付{{ isCardPay ? "" : "（" + checknum + "积分）" }}
          </div>
        </div>
        <!-- 支付 结束 -->
        <!-- 注意事项 开始 -->
        <div class="oilcar_mesg">
          <div class="oilcar_mesgtitle">
            <img
              class="oilcar_mesgimg"
              src="/static/newprojecticon/title.png"
            />
            <div class="oilcar_mesgtext">注意事项</div>
          </div>
          <div class="oilcar_mesgtipspan2">广东中石油加油券</div>
          <div class="oilcar_mesgtip">
            2、请认真核对充值号信息，对个人输入有误产生的售后问题概不受理。
          </div>
        </div>
        <!-- 注意事项 结束 -->
      </div>
      <!-- 广东中石油 结束 -->
      <!-- 油卡充值 开始 -->
      <div v-if="topheadindex === 0">
        <!-- 添加油卡 开始 -->
        <div class="oilcar_top">
          <div
            v-if="!oilCardItem.brand_str"
            class="oilcar_select"
            @click="toCardList()"
            id="toCardList"
          >
            <img src="/static/newicon/jia.png" class="oilcar_jia" />
            <div class="oilcar_jianame">选择油卡</div>
          </div>
          <!--        <div v-if="oilCardItem.id" class="oilcar_select" @click="toCardList()" id="toCardList" style="flex-direction: column;">
          <p class="oilcar_jianame">{{ oilCardItem.brand_str }}</p>
          <p class="oilcar_jianame">{{ oilCardItem.card_no }}</p>
        </div> -->
          <div v-if="oilCardItem.id" class="oilcar_selectoil" id="toCardList">
            <div class="oilcar_numList">
              <p class="oilcar_jianame">{{ oilCardItem.brand_str }}</p>
              <p class="oilcar_jianame">{{ oilCardItem.card_no }}</p>
            </div>
            <div class="oil_change" @click="toCardList()">换油卡</div>
          </div>
        </div>
        <!-- 添加油卡 结束 -->
        <!-- 套餐选择 开始 -->
        <div class="oilcar_taocan">
          <div class="oilcar_taocan_name">请选择充值金额</div>
          <div class="oilcar_taocan_list">
            <div
              :class="
                item.checked1 ? 'oilcar_taocan_box1' : 'oilcar_taocan_box'
              "
              v-for="(item, index) in packageList1"
              @click="selectnum1(index)"
            >
              <div class="oilcar_taocan_num1">{{ item.m_price }}元</div>
              <div class="oilcar_taocan_num">售{{ item.price }}元</div>
              <img
                v-if="item.checked1"
                class="oilcar_taocan_checkimg"
                src="/static/newprojecticon/chongzhicheck.png"
              />
            </div>
          </div>
        </div>
        <!-- 套餐选择 结束 -->
        <!-- <div class="oiltype_taocan">
        <div class="pagepaytype_text">选择支付方式</div>
        <div class="page_shangpin_box" @click="weixinPay1()">
          <div class="page_shangpin_mesgname1">
            <img src="/static/weixinpay.png" class="page_shangpin_mesglogo" />
            <div class="page_shangpin_mesgname">微信支付</div>
          </div>
          <div class="page_shangpin_usejifen">
            <div class="page_shangpin_shoujia">{{ checknum ? checknum+'元' : '' }}</div>
            <img :src="isWeixinPay1? '/static/checkdeicon.png' : '/static/checkicon.png'" class="page_checklogo" />
          </div>
        </div>
        <div class="page_shangpin_box" @click="yuePay1()">
          <div class="page_shangpin_mesgname1">
            <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
            <div class="page_shangpin_mesgname">积分支付</div>
          </div>
          <div class="page_shangpin_usejifen">
            <div class="page_shangpin_keyong">可用积分</div>
            <div class="page_shangpin_shoujia">{{amount}}</div>
            <img :src="isWeixinPay1? '/static/checkicon.png' : '/static/checkdeicon.png'" class="page_checklogo" />
          </div>
        </div>
      </div> -->
        <!-- 支付 开始 -->
        <div class="oilcar_button" @click="zhifu1()">
          <div class="oilcar_zhifu">立即支付（{{ checknum1 }}积分）</div>
        </div>
        <!-- 支付 结束 -->
        <!-- 注意事项 开始 -->
        <div class="oilcar_mesg">
          <div class="oilcar_mesgtitle">
            <img
              class="oilcar_mesgimg"
              src="/static/newprojecticon/title.png"
            />
            <div class="oilcar_mesgtext">注意事项</div>
          </div>
          <div class="oilcar_mesgtip">本服务支持中国石化、中国石油卡充值</div>
          <div class="oilcar_mesgtip">
            充值开放时间为法定工作日8:30～17:30，因近期系统订单较多，充值需排队等待
          </div>
          <div class="oilcar_mesgtipspan">
            请核对录入的油卡号是否正确，如果录入错误无法返回，造成的损失由个人承担
          </div>
          <div class="oilcar_mesgtip">
            充值成功后，请到加油站进行圈存即可消费使用
          </div>
          <div class="oilcar_mesgtipspan">什么叫圈存？</div>
          <div class="oilcar_mesgtip">
            圈存就是将您在线充值的资金，写入（同步）到加油卡的IC卡芯片上，就可以正常加油了
          </div>
          <div class="oilcar_mesgtipspan">怎么圈存？</div>
          <div class="oilcar_mesgtip">A. 去加油站点找工作人员办理圈存</div>
          <div class="oilcar_mesgtip">
            B. 加油站内设有24小时自助圈存机，可自行操作
          </div>
        </div>
        <!-- 注意事项 结束 -->
      </div>
      <!-- 油卡充值 结束 -->
    </div>
    <!-- ！！！！！！只能用大家来加油 start-->
    <div v-else>
      <!-- 返回 开始 -->
      <div class="page_topbox">
        <img
          class="page_topreturn"
          src="/static/fanhui.png"
          @click="pageReturn()"
        />
        <div class="page_toptext">大家来加油</div>
        <img
          class="page_topreturnindex"
          src="/static/fanhuishouye.png"
          @click="pageToIndex()"
        />
      </div>
      <!-- 返回 结束 -->
      <!-- 大家来加油 开始 -->
      <div class="oilcarcenter">
        <!-- 输入手机 开始 -->
        <div class="oilcar_top">
          <div class="oilcar_pname">手机号码</div>
          <div class="oilcar_pnum">
            <input
              class="oilcar_pnuminput"
              @input="phoneNum()"
              placeholder="请输入手机号"
              type="tel"
              value="phone"
              v-model="phonenum"
            />
            <img class="oilcar_pimg" src="/static/newicon/chongzhiphone.png" />
          </div>
          <div class="oilcar_pnum" v-if="phone != phonenum">
            <input
              class="oilcar_pnuminput1"
              type="number"
              placeholder="请输入验证码"
              v-model="phoneCode"
            />
            <div class="oilcar_yanzheng" @click="getPhoneCode()">
              {{ currentTime ? currentTime : "获取验证码" }}
            </div>
          </div>
        </div>
        <!-- 输入手机 结束 -->
        <!-- 套餐选择 开始 -->
        <div :class="phone != phonenum ? 'oilcar_taocan1' : 'oilcar_taocan'">
          <div class="oilcar_taocan_name">请选择充值金额</div>
          <div class="oilcar_taocan_list">
            <div
              :class="item.checked ? 'oilcar_taocan_box1' : 'oilcar_taocan_box'"
              v-for="(item, index) in packageList"
              @click="selectnum(index)"
            >
              <div class="oilcar_taocan_num2">{{ item.name }}</div>
              <img
                v-if="item.checked"
                class="oilcar_taocan_checkimg"
                src="/static/newprojecticon/chongzhicheck.png"
              />
            </div>
          </div>
        </div>
        <!-- 套餐选择 结束 -->
        <!-- 支付方式 开始 -->
        <div :class="phone != phonenum ? 'oiltype_taocan1' : 'oiltype_taocan'">
          <div class="pagepaytype_text">选择支付方式</div>
          <div class="page_shangpin_box" @click="cardPay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/kaquanpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">卡券支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_shoujia">
                {{ cardPrice ? cardPrice + "元" : "" }}
              </div>
              <img
                :src="
                  isCardPay
                    ? '/static/checkdeicon.png'
                    : '/static/checkicon.png'
                "
                class="page_checklogo"
              />
            </div>
          </div>
          <div class="page_shangpin_box" @click="yuePay()">
            <div class="page_shangpin_mesgname1">
              <img src="/static/jifenpay.png" class="page_shangpin_mesglogo" />
              <div class="page_shangpin_mesgname">积分支付</div>
            </div>
            <div class="page_shangpin_usejifen">
              <div class="page_shangpin_keyong">可用积分</div>
              <div class="page_shangpin_shoujia">{{ amount }}</div>
              <img
                :src="
                  isCardPay
                    ? '/static/checkicon.png'
                    : '/static/checkdeicon.png'
                "
                class="page_checklogo"
              />
            </div>
          </div>
        </div>
        <!-- 支付方式 结束 -->
        <!-- 支付 开始 -->
        <div
          :class="phone != phonenum ? 'oilcar_button1' : 'oilcar_button'"
          @click="zhifu2()"
        >
          <div class="oilcar_zhifu">
            立即支付{{ isCardPay ? "" : "（" + checknum + "积分）" }}
          </div>
        </div>
        <!-- 支付 结束 -->
        <!-- 注意事项 开始 -->
        <div class="oilcar_mesg">
          <div class="oilcar_mesgtitle">
            <img
              class="oilcar_mesgimg"
              src="/static/newprojecticon/title.png"
            />
            <div class="oilcar_mesgtext">注意事项</div>
          </div>
          <div class="oilcar_mesgtipspan2">大家来加油是中石化加油券</div>
          <div class="oilcar_mesgtip">
            1、请认真核对充值号信息，对个人输入有误产生的售后问题概不受理。
          </div>
          <div class="oilcar_mesgtip">
            2、充值成功后，搜索“<span class="oilcar_mesgtipspan1"
              >大家来加油</span
            >”小程序，授权微信并使用充值的手机号码登录，点击“电子加油券”设置支付密码后，即可到加油站打开二维码支付使用。
          </div>
        </div>
        <!-- 注意事项 结束 -->
      </div>
      <!-- 大家来加油 结束 -->
    </div>
    <!-- 油卡充值 结束 -->
    <!-- ！！！！！！只能用大家来加油 end-->
  </div>
</template>

<script>
import httper from "../../api/http";
import httpers from "../../api/https";
import { Dialog } from "vant";
var phone_mreg = /^1[2-9][0-9]{9}$/;
export default {
  data() {
    return {
      oilcardnum: "1", //油卡卡号
      phonenum: "", //手机号
      phone: "", //默认手机号
      phoneCode: "", // 验证码,默认为空
      currentCode: "", // 接口获取正确的验证码,默认为空
      currentTime: "", // 验证码倒计时,默认为空
      phoneCodeStatus: false, // 手机领-验证码状态,默认为false
      topHead: [
        {
          name: "油卡充值",
          topselect: true,
          message:
            " 温馨提示\n因第三方充值通道更新后，部分油卡到账时间会有延迟，不便之处，敬请谅解！"
        },
        {
          name: "广东中油BP",
          topselect: false,
          message:
            "注意事项\n1：请认真核对充值号信息，对个人输入有误产生的售后问题概不受理。"
        }
      ],
      topheadindex: 0,
      headname: "油卡充值",
      selectkind: false, //
      selectkindname: "中石化",
      product: "", //商品
      packageList: [
        {
          name: "50元",
          price: "50",
          checked: false
        },
        {
          name: "100元",
          price: "100",
          checked: false
        },
        {
          name: "200元",
          price: "200",
          checked: false
        },
        {
          name: "500元",
          price: "500",
          checked: false
        },
        {
          name: "1000元",
          price: "1000",
          checked: false
        }
      ], //所有套餐列表
      packageList1: [],
      packageIndex: 0, // 充值套餐指针,默认为2
      packageIndex1: 0, // 充值套餐指针,默认为2
      checknum: "", //所选套餐所需积分
      checknum1: "", //所选套餐所需积分
      ischecked: false, //是否选择套餐
      ischecked1: false, //是否选择套餐
      buttonClicked: false, // 防止用户重复点击,默认为false

      id: "", //商品id
      oilCardItem: [], // 选择油卡页面获取油卡,默认为空
      amount: "", // 可用余额
      // settlementItem: [{
      //   amount: '', // 可用余额
      //   canAmountPay: false, // 前端计算可用余额是否大于服务价格,默认为false
      //   isAmountPay: false // 用户是否使用余额结算,默认为false
      // }], // 接口获取结算方式
      showTopTips: [
        {
          text: "请选择您的油卡再充值!",
          checked: false
        }
      ], // 错误提示列表
      order_param: {}, //下单参数
      oilCardList: [], //获取油卡列表
      isWeixinPay: false,
      isWeixinPay1: false,
      isCardPay: false, //卡券支付
      productItemId: 0, //卡券面值id
      onlyCarditem: false, //仅卡券
      cardPrice: 0, //卡券面值
      couponId: 0, //卡券id
      showEveryoneOil: true,
      usershowtab: false
    };
  },
  created() {
    this.request("getUserInfo");
    this.request("getganggang", {
      tab_id: 1
    });
    //
    if (
      sessionStorage.getItem("source") == "sjcmdl" ||
      sessionStorage.getItem("source") == "cxkjdl"
    ) {
      this.showEveryoneOil = false;
    }
    if (this.$route.params.topindex) {
      this.topheadindex = this.$route.params.topindex;
      this.topHead[0].topselect = true;
      this.topHead[1].topselect = false;
      this.headname = this.topHead[0].name;
      console.log("油卡顶部名", this.headname);
    }
    if (this.$route.params.oilCardItem) {
      this.oilCardItem = this.$route.params.oilCardItem;
      // this.topHead[1].topselect = true
      // this.topHead[0].topselect = false
    }

    if (this.$route.query.productItemId) {
      this.productItemId = this.$route.query.productItemId;
      this.cardPrice = this.$route.query.price;
      this.couponId = this.$route.query.couponId;
      this.isCardPay = true;
    } else {
      this.isCardPay = false;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  },
  mounted() {},
  methods: {
    pageReturn() {
      this.$router.go(-1);
    },
    pageToIndex() {
      this.$router.push({
        path: "/"
      });
    },
    /**
     * 防重点击
     * @param duration
     * @returns {Promise<any>}
     */
    buttonClickedFun(duration = 0) {
      this.buttonClicked = true;
      return new Promise((resolve, reject) => {
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            this.buttonClicked = false;
          }, duration);
        }
        resolve(true);
      });
    },
    //返回上一页
    // toReturn() {
    //   this.$router.go(-1)
    // },
    //转去油卡列表页面
    toCardList() {
      this.$router.push({
        path: "/oilCardList"
      });
    },
    //改变顶部导航
    changetophead(e) {
      let that = this;
      let topHead = that.topHead;
      topHead.map((item, index) => (item.topselect = index === Number(e)));
      that.topheadindex = Number(e);
      // if (e == 0) {
      //   Dialog.alert({
      //     title: '提示',
      //     message: '油卡充值功能维护中~，敬请期待',
      //   }).then(() => {
      //     this.topheadindex = 1
      //     this.headname = that.topHead[1].name
      //     topHead[1].topselect = true
      //     topHead[0].topselect = false
      //   });
      // }
      that.headname = that.topHead[e].name;
    },
    //改变中石化/中石油的tabhead
    changeTabHead(e) {
      let that = this;
      let tabHead = this.tabHead;
      tabHead.map((item, index) => (item.isselect = index === Number(e)));
      that.selectkind = that.tabHead[Number(e)].isselect;
      that.selectkindname = that.tabHead[Number(e)].name;
    },
    //选中的套餐
    selectnum(e) {
      let that = this;
      // this.onlyCarditem = false
      // if (this.isCardPay) {
      //   Dialog.confirm({
      //       title: '提示',
      //       message: '所选金额与卡券面值不一致，不可使用卡券支付',
      //     })
      //     .then(() => {
      //       let packageList = that.packageList
      //       packageList.map((item, index) => item.checked = index === Number(e))
      //       that.checknum = that.packageList[Number(e)].price
      //       that.packageIndex = Number(e)
      //       that.ischecked = true
      //       this.isCardPay = false
      //     })
      //     .catch(() => {
      //       return false;
      //     });
      // } else {
      //   let packageList = that.packageList
      //   packageList.map((item, index) => item.checked = index === Number(e))
      //   that.checknum = that.packageList[Number(e)].price
      //   that.packageIndex = Number(e)
      //   that.ischecked = true
      // }

      let packageList = that.packageList;
      packageList.map((item, index) => (item.checked = index === Number(e)));
      that.checknum = that.packageList[Number(e)].price;
      that.packageIndex = Number(e);
      that.ischecked = true;
    },
    //油卡充值选中的套餐
    selectnum1(e) {
      let that = this;
      let packageList = that.packageList1;
      packageList.map((item, index) => (item.checked1 = index === Number(e)));
      that.checknum1 = that.packageList1[Number(e)].price;
      that.packageIndex1 = Number(e);
      that.ischecked1 = true;
    },
    //(大家来加油) 卡券支付
    cardPay() {
      let that = this;
      // this.isCardPay = true
      that.$router.push({
        path: "/couponsList"
      });
      // if (that.isCardPay) {
      //   that.$router.push({
      //     path: "/couponsList"
      //   })
      // } else {
      //   if (that.productItemId == 0) {
      //     Dialog.confirm({
      //         title: '提示',
      //         message: '请到卡券列表选择合适的卡券',
      //       })
      //       .then(() => {
      //         that.$router.push({
      //           path: "/couponsList"
      //         })
      //       })
      //       .catch(() => {
      //         return false;
      //       });
      //   } else {
      //     let packageList = that.packageList
      //     let packageIndex = that.packageIndex
      //     if (packageList[packageIndex].id == that.productItemId) {
      //       this.isCardPay = true
      //     } else {
      //       Dialog.alert({
      //           title: '提示',
      //           message: '所选金额与卡券面值不一致，不可使用卡券支付',
      //         })
      //         .then(() => {
      //           this.isCardPay = false
      //         })
      //     }
      //   }
      // }
    },
    //(大家来加油)微信支付
    weixinPay() {
      this.isWeixinPay = true;
    },
    //(大家来加油)余额支付
    yuePay() {
      this.isCardPay = false;
      this.isWeixinPay = false;
    },
    //微信支付
    weixinPay1() {
      this.isWeixinPay1 = true;
    },
    //余额支付
    yuePay1() {
      this.isWeixinPay1 = false;
    },
    //油卡充值
    zhifu1() {
      let that = this;
      this.buttonClickedFun(1000); // 防止重复点击
      if (!!that.oilCardItem.card_no) {
        //下单参数
        var product_item = that.packageList1[that.packageIndex1];
        var order_param = that.order_param;
        order_param.product_id = product.id
        order_param.amount = product_item.price;
        order_param.type = "online";
        order_param.product_type = 3;
        order_param.product_item_id = product_item.id;
        order_param.recharge_number = that.oilCardItem.card_no;
        order_param.oil_name = that.headname;
        // order_param.pay_type = 'wechatpay'
        // 判断是否余额结算,若走微信支付则需要判断是否有授权手机(待施工
        // if (this.isWeixinPay1) {
        //   Dialog.confirm({
        //       title: '提示',
        //       message: '是否使用微信支付?',
        //     })
        //     .then(() => {
        //       // order_param.pay_type = 'balance'
        //       // that.request('YeunifiedOrder', order_param)
        //       order_param.pay_type = 'wechatpay'
        //       that.request('WxunifiedOrder', order_param)
        //     })
        //     .catch(() => {
        //       return false;
        //     });
        // } else {
        if (parseFloat(that.amount) < parseFloat(product_item.price)) {
          Dialog.confirm({
            title: "提示",
            message: "积分不足，前往充值？"
          })
            .then(() => {
              that.$router.push({
                path: "/account"
              });
            })
            .catch(() => {
              return false;
            });
        } else {
          // Dialog.confirm({
          //     title: '提示',
          //     message: '是否用余额支付?',
          //   })
          //   .then(() => {
          //     order_param.pay_type = 'balance'
          //     that.request('YeunifiedOrder', order_param)
          //   })
          //   .catch(() => {
          //     return false;
          //   });
          Dialog.confirm({
            title: "提示",
            message:
              "请认真核对油卡号\n" + that.oilCardItem.card_no + "\n充错无法返回"
          })
            .then(() => {
              order_param.pay_type = "balance";
              console.log("order", order_param);
              that.request("YeunifiedOrder", order_param);
            })
            .catch(() => {
              return false;
            });
        }
        //}
      } else {
        this.$toast({
          message: "请选择油卡"
        });
      }
    },
    //仅大家来加油
    zhifu2() {
      let that = this;
      this.buttonClickedFun(1000); // 防止重复点击
      let packageIndex = that.packageIndex;
      if (that.isCardPay) {
        if (that.packageList[packageIndex].id != that.productItemId) {
          Dialog.confirm({
            title: "提示",
            message:
              "所选金额与卡券面值不一致，不可使用卡券支付,是否使用积分支付"
          })
            .then(() => {
              this.isCardPay = false;
            })
            .catch(() => {
              return false;
            });
          return;
        }
      }
      // 手机号码格式错误时顶部显示错误提示2秒
      if (!/^1[0-9]{10}$/.test(that.phonenum)) {
        this.$toast({
          message: "手机号码格式错误"
        });
        return;
      }
      if (that.phone != that.phonenum) {
        if (!that.phoneCode || that.phoneCode != that.currentCode) {
          this.$toast({
            message: "请输入正确的验证码"
          });
          return;
        }
      }

      if (!!this.oilcardnum && !!this.phonenum) {
        //下单参数
        var product_item = that.packageList[that.packageIndex];
        var order_param = that.order_param;
        order_param.amount = product_item.price;
        order_param.type = "online";
        order_param.product_type = 3;
        order_param.product_item_id = product_item.id;
        order_param.recharge_number = that.phonenum; //供应商只有鼎聚，手机号就是充值卡号
        // order_param.oil_name = that.headname
        order_param.oil_name = "大家来加油";
        console.log("name", order_param.oil_name);
        // order_param.pay_type = 'wechatpay'
        // 判断是否余额结算,若走微信支付则需要判断是否有授权手机(待施工
        console.log(
          "that.amount < product_item.price",
          that.amount < product_item.price
        );
        console.log("that.amount", that.amount);
        console.log("product_item.price", product_item.price);
        // if (this.isWeixinPay) {
        //   Dialog.confirm({
        //       title: '提示',
        //       message: '请核对手机号' + this.phonenum,
        //     })
        //     .then(() => {
        //       // order_param.pay_type = 'balance'
        //       // that.request('YeunifiedOrder', order_param)
        //       order_param.pay_type = 'wechatpay'
        //       that.request('WxunifiedOrder', order_param)
        //     })
        //     .catch(() => {
        //       return false;
        //     });
        // } else {
        if (parseFloat(that.amount) < parseFloat(product_item.price)) {
          Dialog.confirm({
            title: "提示",
            message: "积分不足，前往充值？"
          })
            .then(() => {
              that.$router.push({
                path: "/account"
              });
            })
            .catch(() => {
              return false;
            });
        } else {
          console.log(that.topHead[that.topheadindex]);
          Dialog.confirm({
            title: "提示",
            message: "请核对手机号" + this.phonenum
          })
            .then(() => {
              if (that.isCardPay) {
                order_param.pay_type = "coupon";
                order_param.coupon_id = that.couponId;
              } else {
                order_param.pay_type = "balance";
              }
              console.log("大家来加油", order_param);
              that.request("YeunifiedOrder", order_param);
            })
            .catch(() => {
              return false;
            });
        }
        //}
      }
    },
    //中石油
    zhifu() {
      let that = this;
      this.buttonClickedFun(1000); // 防止重复点击
      let packageIndex = that.packageIndex;
      if (that.isCardPay) {
        if (that.packageList[packageIndex].id != that.productItemId) {
          Dialog.confirm({
            title: "提示",
            message:
              "所选金额与卡券面值不一致，不可使用卡券支付,是否使用积分支付"
          })
            .then(() => {
              this.isCardPay = false;
            })
            .catch(() => {
              return false;
            });
          return;
        }
      }
      // 手机号码格式错误时顶部显示错误提示2秒
      if (!/^1[0-9]{10}$/.test(that.phonenum)) {
        this.$toast({
          message: "手机号码格式错误"
        });
        return;
      }
      if (that.phone != that.phonenum) {
        if (!that.phoneCode || that.phoneCode != that.currentCode) {
          this.$toast({
            message: "请输入正确的验证码"
          });
          return;
        }
      }

      if (!!this.oilcardnum && !!this.phonenum) {
        //下单参数
        var product_item = that.packageList[that.packageIndex];
        var order_param = that.order_param;
        order_param.amount = product_item.price;
        order_param.type = "online";
        order_param.product_type = 3;
        order_param.product_item_id = product_item.id;
        order_param.recharge_number = that.phonenum; //供应商只有鼎聚，手机号就是充值卡号
        order_param.oil_name = that.headname;
        //order_param.oil_name = "大家来加油"
        console.log("name", that.headname);
        // order_param.pay_type = 'wechatpay'
        // 判断是否余额结算,若走微信支付则需要判断是否有授权手机(待施工
        console.log(
          "that.amount < product_item.price",
          that.amount < product_item.price
        );
        console.log("that.amount", that.amount);
        console.log("product_item.price", product_item.price);
        // if (this.isWeixinPay) {
        //   Dialog.confirm({
        //       title: '提示',
        //       message: '请核对手机号' + this.phonenum,
        //     })
        //     .then(() => {
        //       // order_param.pay_type = 'balance'
        //       // that.request('YeunifiedOrder', order_param)
        //       order_param.pay_type = 'wechatpay'
        //       that.request('WxunifiedOrder', order_param)
        //     })
        //     .catch(() => {
        //       return false;
        //     });
        // } else {
        if (parseFloat(that.amount) < parseFloat(product_item.price)) {
          Dialog.confirm({
            title: "提示",
            message: "积分不足，前往充值？"
          })
            .then(() => {
              that.$router.push({
                path: "/account"
              });
            })
            .catch(() => {
              return false;
            });
        } else {
          console.log(that.topHead[that.topheadindex]);
          Dialog.confirm({
            title: "提示",
            message: "请核对手机号" + this.phonenum
          })
            .then(() => {
              if (that.isCardPay) {
                order_param.pay_type = "coupon";
                order_param.coupon_id = that.couponId;
              } else {
                order_param.pay_type = "balance";
              }
              console.log("param中石油", order_param);
              that.request("YeunifiedOrder", order_param);
            })
            .catch(() => {
              return false;
            });
        }
        //}
      }
    },
    //输入手机号时触发
    phoneNum() {
      let that = this;
      that.phonenum = this.phonenum;
      that.phoneCodeStatus = phone_mreg.test(this.phonenum);
    },
    //获取验证码
    getPhoneCode() {
      let that = this;
      let requestData = {};
      // 获取验证码
      that.buttonClickedFun(1500);
      if (!that.phoneCodeStatus) {
        this.$toast({
          message: "请输入正确的手机号"
        });
        return;
      }
      if (!that.phonenum) {
        this.$toast({
          message: "请输入手机号"
        });
        return;
      }
      if (that.phoneCodeStatus && that.phonenum) {
        requestData.mobile = that.phonenum;
        this.request("sendCode", requestData);
      }
    },
    request(type = "", requestData = {}) {
      let that = this;
      let data = {};
      switch (type) {
        //获取用户信息
        case "getUserInfo":
          httper.get(
            "wechat/user/info",
            requestData,
            res => {
              if (res.code === 0) {
                let userinfo = res.data;
                console.log("userinfo", userinfo);
                console.log("usershowtab", this.usershowtab);
                // sessionStorage.setItem('userinfo', JSON.stringify(userinfo))
                //that.phoneNum = userinfo.mobile ? userinfo.mobile : 'meiyou'
                that.amount = userinfo.account.amount;
                that.phone = userinfo.mobile;
                that.phonenum = that.phone;
                //usershowtab
                var userId = [42, 45, 46, 49, 50, 86, 167];
                for (var i = 0; i < userId.length; i++) {
                  if (userId[i] == userinfo.id) {
                    that.usershowtab = true;
                  }
                }
                console.log("usershowtab", this.usershowtab);
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
        // 发送短息验证码
        case "sendCode":
          httpers.post("msg/send-code", requestData, res => {
            console.log("code：", res.data);
            if (res.code == 0) {
              that.currentCode = res.data;
              this.$toast({
                message: "验证码已发送"
              });
              // 倒计时
              let time = 91;
              let interval = setInterval(() => {
                time--;
                if (time > 10) {
                  that.currentTime = time + "秒";
                }
                if (time > 0 && time <= 10) {
                  that.currentTime = " " + time + "秒";
                }
                if (time <= 0) {
                  clearInterval(interval);
                  that.currentTime = "";
                }
              }, 1000);
            }
          });
          break;
        //刚进入页面获取的数据
        case "getganggang":
          httper.get(
            "/product/get-online-by-api-tab",
            requestData,
            res => {
              if (res.code == 0) {
                console.log("res", res);
                let product = res.data[0];
                this.product = product
                let fakeData2 = product.productItem; //大家来加油面值
                let fakeData3 = []; //油卡充值面值
                if (this.isCardPay) {
                  fakeData2.map(
                    (item, index) =>
                      (item.checked = item.id === that.productItemId)
                  );
                  for (let i = 0; i < fakeData2.length; i++) {
                    if (fakeData2[i].checked) {
                      that.checknum = fakeData2[i].price;
                      that.packageIndex = Number(i);
                    }
                  }
                } else {
                  fakeData2.map(
                    (item, index) =>
                      (item.checked = index === that.packageIndex)
                  );
                  that.checknum = fakeData2[that.packageIndex].price;
                }
                for (let i = 0; i < fakeData2.length; i++) {
                  if (parseFloat(fakeData2[i].price) >= 100) {
                    fakeData3.push(fakeData2[i]);
                  }
                }
                fakeData3.map(
                  (item, index) =>
                    (item.checked1 = index === that.packageIndex1)
                );
                console.log("fakeData3", fakeData3);
                console.log("packageList", fakeData2);
                that.packageList1 = fakeData3;
                that.packageList = fakeData2;
                that.checknum1 = fakeData3[that.packageIndex1].price;

                // var settlementItem = that.settlementItem
                // settlementItem.canAmountPay = settlementItem.amount >= parseFloat(fakeData2[that.packageIndex].price)
                // if (settlementItem.canAmountPay) {
                //   that.settlementItem.isAmountPay = ture
                // }
                // that.settlementItem = settlementItem
              } else {
                that.$toast({
                  message: res.data.message || "系统异常"
                });
              }
            },
            false
          );
          break;
        //余额支付
        case "YeunifiedOrder":
          this.$indicator.open();
          httper.post(
            "/payment/place-order",
            requestData,
            res => {
              that.$indicator.close();
              // that.$toast({
              //   message: '下单成功'
              // })

              if (res.code === 0) {
                Dialog.alert({
                  title: "下单成功",
                  message: that.topHead[that.topheadindex].message
                }).then(() => {
                  that.isCardPay = false;
                  setTimeout(function() {
                    that.$router.push({
                      path: "/orderListDetail",
                      query: {
                        id: res.data.order_no
                      }
                    });
                  }, 1000);
                });

                // wx.navigateTo({
                //     url: '/pages/order/detail?id=' + res.data.order_no
                // })
              } else {
                that.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
        //微信下单
        case "WxunifiedOrder":
          httper.post(
            "/payment/place-order",
            requestData,
            res => {
              console.log("微信支付信息", res);
              if (res.code === 0) {
                that.pay(res.data.payment_packet, res.data.order_no);
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
        //微信取消下单
        case "orderCancel":
          httper.post(
            "/order/cancel",
            requestData,
            res => {
              console.log("取消", res);
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || "系统异常"
                });
              }
            },
            true
          );
          break;
      }
    },
    //发起支付
    pay(payment_packet, order_no) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.jsApiCall(payment_packet, order_no),
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent(
            "WeixinJSBridgeReady",
            this.jsApiCall(payment_packet, order_no)
          );
          document.attachEvent(
            "onWeixinJSBridgeReady",
            this.jsApiCall(payment_packet, order_no)
          );
        }
      } else {
        this.jsApiCall(payment_packet, order_no);
      }
    },
    //调用微信支付
    jsApiCall(payment_packet, order_no) {
      let that = this;
      if (!payment_packet) {
        this.$toast({
          message: "下单失败，请重试"
        });
        return;
      }
      WeixinJSBridge.invoke("getBrandWCPayRequest", payment_packet, function(
        res
      ) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
          //跳去详情页order_no
          that.$router.push({
            path: "/orderListDetail",
            query: {
              id: order_no
            }
          });
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          this.$toast({
            message: "取消支付"
          });
          this.request("orderCancel", {
            order_id: order_no
          });
          // that.$router.push({
          //   name: 'list'
          // })
        } else {
          this.$toast({
            message: "支付失败"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
body {
  background-color: #efeef3;
  margin: 0;
}

.oilcar_tab {
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.oilcar_tablist {
  height: 100%;
  position: relative;
}

.oilcar_tabname {
  height: 100%;
  display: flex;
  font-size: 13px;
  align-items: center;
}

.oilcar_tabname::after {
  content: "";
  top: auto;
  bottom: 0;
  width: 40%;
  position: absolute;
  left: 25%;
  height: 3px;
  background-color: #fd8c00;
}

.oilcar_tabname1 {
  height: 100%;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.oilcar_top {
  width: 90%;
  height: 184px;
  background: #fd8c00;
  padding: 20px;
  position: relative;
  color: #fff;
}

.oilcar_pname {
  color: hsla(0, 0%, 100%, 1);
  padding: 0 10px;
}

.oilcar_pnum {
  display: flex;
  align-items: center;
  margin-top: 10px;
  border-bottom: 1px solid hsla(0, 0%, 100%, 1);
  justify-content: space-between;
  padding: 10px;
}

.oilcar_pnuminput {
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 26px;
  font-weight: bold;
}

.oilcar_pnuminput1 {
  width: 70%;
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 26px;
  font-weight: bold;
}

::-webkit-input-placeholder {
  text-align: start;
  color: hsla(0, 0%, 100%, 1);
  font-size: 16px;
}

.oilcar_pimg {
  width: 20px;
  height: 20px;
}

.oilcar_taocan {
  width: 84%;
  min-height: 191px;
  padding: 10px 10px 20px 10px;
  margin: 0 20px;
  box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
  border-radius: 5px;
  /* position: absolute;
    top: 180px;
    background-color: #fff; */
  position: relative;
  top: -85px;
  background-color: #fff;
}

.oilcar_taocan_name {
  font-weight: 400;
  color: rgba(54, 54, 54, 1);
}

.oilcar_taocan_list {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-evenly; */
  align-items: center;
}

.oilcar_taocan_box {
  width: 30%;
  height: 46px;
  font-weight: 400;
  color: rgba(54, 54, 54, 1);
  border: 1px solid rgba(124, 124, 124, 1);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-right: 5px;
}

.oilcar_taocan_box1 {
  width: 30%;
  height: 46px;
  font-weight: bold;
  color: #fd8c00;
  background: rgba(253, 140, 0, 0.1);
  border: 1px solid rgba(253, 140, 0, 1);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  position: relative;
  margin-right: 5px;
}

.oilcar_taocan_num {
  font-size: 14px;
}

.oilcar_taocan_num1 {
  font-size: 16px;
  font-weight: bold;
}

.oilcar_taocan_num2 {
  font-size: 22px;
  font-weight: bold;
}

.oilcar_taocan_checkimg {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.oilcar_button {
  margin: 0 30px;
  /* margin: 150px 30px 0 30px; */
  width: 82%;
  height: 46px;

  /* background: linear-gradient(90deg, rgba(233, 109, 86, 1) 0%, rgba(226, 81, 62, 1) 100%); */
  background: #fd8c00;
  box-shadow: 0 5px 7px 2px rgba(253, 140, 0, 0.3);
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.oilcar_zhifu {
}

.oilcar_mesg {
  width: 89%;
  padding: 20px;
}

.oilcar_mesgtitle {
  display: flex;
}

.oilcar_mesgimg {
  width: 4px;
  height: 23px;
  margin-right: 10px;
}

.oilcar_mesgtext {
}

.oilcar_mesgtip {
  margin-left: 20px;
}

.oilcar_mesgtipspan {
  margin-left: 20px;
  color: #fd8c00;
}

.oilcar_mesgtipspan1 {
  color: #fd8c00;
}

.oilcar_mesgtipspan2 {
  margin-left: 20px;
  font-weight: bold;
  font-size: 18px;
  color: #fd8c00;
}

.oilcar_select {
  height: 90px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.oilcar_selectoil {
  height: 90px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.oilcar_numList {
}

.oil_change {
  width: 58px;
  height: 23px;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 15px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.oilcar_jia {
  width: 23px;
  height: 23px;
}

.oilcar_jianame {
  font-size: 15px;
}

.oilcar_taocanyouka {
  width: 84%;
  height: 170px;
  padding: 10px;
  margin: 0 20px;
  box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
  border-radius: 5px;
  position: absolute;
  top: 160px;
  background-color: #fff;
}

.oilcar_taocan1 {
  width: 84%;
  height: 191px;
  padding: 10px;
  margin: 0 20px;
  box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
  border-radius: 5px;
  /* position: absolute;
    top: 235px;
    background-color: #fff; */
  position: relative;
  top: -35px;
  background-color: #fff;
}

.oilcar_button1 {
  margin: 0 30px;
  /* margin: 190px 30px 0 30px; */
  width: 82%;
  height: 46px;
  background: #fd8c00;
  box-shadow: 0 5px 7px 2px rgba(253, 140, 0, 0.3);
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.oilcar_yanzheng {
  width: 30%;
  height: 31px;
  border: 1px solid #fff;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.oiltype_taocan {
  width: calc(100% - 40px);
  margin: -60px 20px 20px;
  box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
  border-radius: 5px;
  padding: 20px 10px;
  box-sizing: border-box;
}

.oiltype_taocan1 {
  width: calc(100% - 40px);
  margin: -20px 20px 20px;
  box-shadow: 0px 5px 7px 2px rgba(187, 187, 187, 0.3);
  border-radius: 5px;
  padding: 20px 10px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/oilcard/oilCard.vue